export const FETCH_REFUND_STATUS_PENDING = 'FETCH_REFUND_STATU_PENDINGS';
export const FETCH_REFUND_STATUS_FULFILLED = 'FETCH_REFUND_STATUS_FULFILLED';
export const FETCH_REFUND_STATUS_FAILED = 'FETCH_REFUND_STATUS_FAILED';

//constants for refunds
